const ClosureSurvey = {}

export default ClosureSurvey
